module.exports = __webpack_public_path__ + "img/bimboot2.471f2736.png";